export const environment = {
  production: false,
  apiKeys: 'AIzaSyDanBliCzAuCZrsq67FeKEs3vqAilUD_is',
  apiMapKey: 'AIzaSyCU0ArzZlZ3n0pLq4o9MJy29LPT5DBMk4Y',
  backendLink: 'https://greencity.greencity.cx.ua/',
  backendChatLink: 'https://greencity-chat.greencity.cx.ua/',
  backendUserLink: 'https://greencity-user.greencity.cx.ua/',
  backendUbsLink: 'https://greencity-ubs.greencity.cx.ua',
  frontendLink: 'https://www.greencity.cx.ua/',
  socket: 'https://greencity.greencity.cx.ua/socket',
  userSocket: 'https://greencity-user.greencity.cx.ua/socket',
  chatSocket: 'https://greencity-chat.greencity.cx.ua/socket',
  ubsAdmin: {
    backendUbsAdminLink: 'https://greencity-ubs.greencity.cx.ua/ubs'
  },
  googleClientId: '129513550972-pg3ueh62gbde1jukmr49vem2rclde123.apps.googleusercontent.com',
  agmCoreModuleApiKey: 'AIzaSyC7q2v0VgRy60dAoItfv3IJhfJQEEoeqCI'
};
